export default __webpack_public_path__ + "images/data-dashboard-1.0bcd06be5c18ba295975ba1e1c42b046.png";